var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RouterView',{attrs:{"name":"header"}}),_c('div',[_c('RouterView',{attrs:{"name":"navigation"}})],1),_c('div',[_c('RouterView',{attrs:{"name":"default"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }